import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { formatMoney, RoundingStrategy } from "@faire/web--source/common/money";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var useFormattedTerms = function(terms) {
    var localeKey = useLocalization().localeKey;
    var isEurope = useRetailerStore([
        "isEurope"
    ]).isEurope;
    var _localeKey_language;
    var isEnglish = ((_localeKey_language = localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) !== null && _localeKey_language !== void 0 ? _localeKey_language : Language.ENG) === Language.ENG;
    var shouldUseCompact = isEnglish && !isEurope;
    return formatMoney({
        money: terms,
        compact: shouldUseCompact,
        roundingStrategy: RoundingStrategy.DROP_CENTS
    });
};
